// extracted by mini-css-extract-plugin
export var displayNone = "_qy-6";
export var imgContainer = "_qy-2";
export var overflowHidden = "_qy-3";
export var productInfoCardButtonContainer = "_qy-5";
export var productTitleText = "_qy-4";
export var rightArrow = "_qy-1";
export var rightArrowContainer = "_qy-0";